import React, { useState, useEffect } from 'react'
import Color from 'color'
import { useNavigate } from 'react-router-dom'

import AppState from './state'
import { resolveTranslations } from '../common/labels'
import { getQueryParams } from '../common/util'

const SplashScreen = props => {
  const [termsAccepted, setTermsAccepted] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    setTermsAccepted(!props.splash.footer)
  }, [props.splash.footer])

  const go = () => {
    AppState.setSplashDone(true)
    const params = getQueryParams()

    if (AppState.hasIntro() && !AppState.introDone()) {
      navigate('/intro' + document.location.search, { replace: true })
    } else if (params.p) {
      navigate(params.p, { replace: true })
    } else {
      navigate('/' + document.location.search, { replace: true })
    }
  }

  const tr = value => {
    return resolveTranslations(value, props.locale, props.bot)
  }

  const { bot, locale, splash } = props

  const mainColor = Color(bot.pwa.manifest.theme_color)

  return (
    <div
      className={`splash-screen--wrapper splash ${mainColor.isLight() ? 'light' : 'dark'}`}
      style={{ backgroundColor: mainColor }}
    >
      <div className="top" />
      <div className="header">
        <div className="avatar" style={{ backgroundImage: `url(${bot.profile_picture})` }} />
        <h1>
          <span dangerouslySetInnerHTML={{ __html: tr(splash.title) }} />
        </h1>
        <p dangerouslySetInnerHTML={{ __html: tr(splash.description) }} />
      </div>

      <div className="cta">
        <button onClick={() => go()} disabled={!termsAccepted}>
          {tr(splash.call_to_action)}
        </button>
      </div>
      {splash.footer ? (
        <label className="footer">
          <input type="checkbox" onChange={e => setTermsAccepted(e.target.checked)} />
          <span className="checkmark"></span>
          <span className="text" dangerouslySetInnerHTML={{ __html: tr(splash.footer) }} />
        </label>
      ) : null}
    </div>
  )
}

export default SplashScreen
